import { ExperimentConfig, ExperimentDefinition } from './types';

function defineExperiment<const V extends Record<string, string>>(
	exp: ExperimentDefinition<V>
): ExperimentDefinition<V> {
	return exp;
}

// DeepLinks
// ?new_preferred_variant=[EXP_NAME]:[VARIANT_NAME]
// ?new_remove_preferred_experiment=[EXP_NAME]
export const experimentConfig = {
	// ?new_preferred_variant=DOUBLE_STACK_EXP_3:control
	// ?new_preferred_variant=DOUBLE_STACK_EXP_3:variant_1
	// ?new_preferred_variant=DOUBLE_STACK_EXP_3:variant_2
	// ?new_remove_preferred_experiment=DOUBLE_STACK_EXP_3
	DOUBLE_STACK_EXP_3: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'dstack3',
	}),
	// ?new_preferred_variant=EXP_JWTV_AVOD:control
	// ?new_preferred_variant=EXP_JWTV_AVOD:variant_1
	// ?new_preferred_variant=EXP_JWTV_AVOD:variant_2
	// ?new_remove_preferred_experiment=EXP_JWTV_AVOD
	EXP_JWTV_AVOD: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1', VARIANT_2: 'variant_2' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'monetization',
		affiliationShortId: 'jwtavod',
	}),
	// ?new_preferred_variant=EXP_GRID_SWIPER:control
	// ?new_preferred_variant=EXP_GRID_SWIPER:variant_1
	// ?new_preferred_variant=EXP_GRID_SWIPER:variant_2
	// ?new_remove_preferred_experiment=EXP_GRID_SWIPER
	EXP_GRID_SWIPER: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1', VARIANT_2: 'variant_2' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'gridsw',
	}),

	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:control
	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:variant_1
	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:variant_2
	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:variant_3
	// ?new_preferred_variant=EXP_GRID_REDESIGN_CLICK:variant_4
	// ?new_remove_preferred_experiment=EXP_GRID_REDESIGN_CLICK
	EXP_GRID_REDESIGN_CLICK: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'grclick',
	}),
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:control
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_1
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_2
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_3
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_4
	// ?new_preferred_variant=EXP_GRID_REDESIGN_MORE_INFO:variant_5
	// ?new_remove_preferred_experiment=EXP_GRID_REDESIGN_MORE_INFO
	EXP_GRID_REDESIGN_MORE_INFO: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
			VARIANT_5: 'variant_5',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'grinfo',
	}),
	// ?new_preferred_variant=EXP_PRE_ROLL_GRID:control
	// ?new_preferred_variant=EXP_PRE_ROLL_GRID:variant_1
	// ?new_preferred_variant=EXP_PRE_ROLL_GRID:variant_2
	// ?new_preferred_variant=EXP_PRE_ROLL_GRID:variant_3
	// ?new_remove_preferred_experiment=EXP_PRE_ROLL_GRID
	EXP_PRE_ROLL_GRID: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'preroll',
	}),
	// ?new_preferred_variant=EXP_SOFTER_FREE_TRIAL_V2:control
	// ?new_preferred_variant=EXP_SOFTER_FREE_TRIAL_V2:variant_1
	// ?new_remove_preferred_experiment=EXP_SOFTER_FREE_TRIAL_V2
	EXP_SOFTER_FREE_TRIAL_V2: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'softl2',
	}),

	// ?new_preferred_variant=EXP_MERGE_BUY_RENT:control
	// ?new_preferred_variant=EXP_MERGE_BUY_RENT:variant_1
	// ?new_preferred_variant=EXP_MERGE_BUY_RENT:variant_2
	// ?new_preferred_variant=EXP_MERGE_BUY_RENT:variant_3
	// ?new_remove_preferred_experiment=EXP_MERGE_BUY_RENT
	EXP_MERGE_BUY_RENT: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1', VARIANT_2: 'variant_2', VARIANT_3: 'variant_3' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'brent',
	}),
	// ?new_preferred_variant=EXP_APPLE_BINGE_2:control
	// ?new_preferred_variant=EXP_APPLE_BINGE_2:variant_1
	// ?new_remove_preferred_experiment=EXP_APPLE_BINGE_2
	EXP_APPLE_BINGE_2: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'monetization',
		affiliationShortId: 'appbin2',
	}),
	// ?new_preferred_variant=EXP_PRIME_PLAY_PROMO:control
	// ?new_preferred_variant=EXP_PRIME_PLAY_PROMO:variant_1
	// ?new_remove_preferred_experiment=EXP_PRIME_PLAY_PROMO
	EXP_PRIME_PLAY_PROMO: defineExperiment({
		variants: { CONTROL: 'control', VARIANT_1: 'variant_1' },
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'proplay',
	}),
	// ?new_preferred_variant=EXP_PROVIDER_BUYBOX:control
	// ?new_preferred_variant=EXP_PROVIDER_BUYBOX:variant_1
	// ?new_preferred_variant=EXP_PROVIDER_BUYBOX:variant_2
	// ?new_preferred_variant=EXP_PROVIDER_BUYBOX:variant_3
	// ?new_preferred_variant=EXP_PROVIDER_BUYBOX:variant_4
	// ?new_remove_preferred_experiment=EXP_PROVIDER_BUYBOX
	EXP_PROVIDER_BUYBOX: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'pfx',
	}),
	// ?new_preferred_variant=EXP_JWTV_TVOD_CINEMATIC_V2:control
	// ?new_preferred_variant=EXP_JWTV_TVOD_CINEMATIC_V2:variant_1
	// ?new_preferred_variant=EXP_JWTV_TVOD_CINEMATIC_V2:variant_2
	// ?new_preferred_variant=EXP_JWTV_TVOD_CINEMATIC_V2:variant_3
	// ?new_preferred_variant=EXP_JWTV_TVOD_CINEMATIC_V2:variant_4
	// ?new_preferred_variant=EXP_JWTV_TVOD_CINEMATIC_V2:variant_5
	// ?new_remove_preferred_experiment=EXP_JWTV_TVOD_CINEMATIC_V2
	EXP_JWTV_TVOD_CINEMATIC_V2: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
			VARIANT_5: 'variant_5',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT', 'LOGGED_IN'],
		type: 'regular',
	}),
	// ?new_preferred_variant=EXP_UNDERPERFORMING_URLS_4:control
	// ?new_preferred_variant=EXP_UNDERPERFORMING_URLS_4:variant_1
	// ?new_preferred_variant=EXP_UNDERPERFORMING_URLS_4:variant_2
	// ?new_remove_preferred_experiment=EXP_UNDERPERFORMING_URLS_4
	EXP_UNDERPERFORMING_URLS_4: defineExperiment({
		variants: {
			CONTROL: 'control',
			VARIANT_1: 'variant_1',
			VARIANT_2: 'variant_2',
			VARIANT_3: 'variant_3',
			VARIANT_4: 'variant_4',
		},
		routes: [],
		tabs: ['detail'],
		userTypes: ['LOGGED_OUT'],
		type: 'monetization',
		affiliationShortId: 'udpurl4',
	}),
} satisfies ExperimentConfig;
